import Amplify from 'aws-amplify';
import clssConfig from 'Config';

export { Auth } from 'aws-amplify';

export const configureAmplify = () => {
  Amplify.configure(clssConfig.amplify);
};
